import type { FC } from 'react';
import { StyleSheet, Text } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import LoadingIndicator from 'src/presentation/components/molecules/LoadingIndicator';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

export type Props = {
	message?: string;
};

const LoadingOverlay: FC<Props> = ({ message }) => {
	return (
		<Animated.View entering={FadeIn} exiting={FadeOut} style={styles.overlay}>
			<LoadingIndicator size={'small'} />
			{message ? <Text style={styles.message}>{message}</Text> : null}
		</Animated.View>
	);
};

const styles = StyleSheet.create({
	overlay: {
		backgroundColor: Colors.whiteE6,
		position: 'absolute',
		left: Dimens.padding0,
		right: Dimens.padding0,
		bottom: Dimens.padding0,
		top: Dimens.padding0,
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: Dimens.zIndexModal,
		padding: Dimens.padding18,
	},
	message: {
		marginTop: Dimens.padding10,
		color: Colors.gray600,
	},
});

export default LoadingOverlay;
